import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, Signal, numberAttribute } from '@angular/core';
import { MatPaginatorIntl, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { queryStateConfig, queryStateConfigSentrynel } from 'src/app/config/query.config';
import { IPageEvent, IPageable, IPageableSentrynel } from 'src/app/core/models/paginator.model';
import { MyMatPaginatorIntl } from 'src/app/core/services/mat-paginator.service';
import { ScreenService } from 'src/app/core/services/screen.service';

@Component({
  selector: 'app-paginator-sentrynel',
  standalone: true,
  imports: [
    CommonModule,
    MatPaginatorModule
  ],
  providers: [
    {
      provide: MatPaginatorIntl,
      useClass: MyMatPaginatorIntl
    }
  ],
  templateUrl: './paginator-sentrynel.component.html',
  styleUrl: './paginator-sentrynel.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaginatorSentrynelComponent {
  @Input({ transform: numberAttribute }) pageSize: number = queryStateConfigSentrynel.initState?.meta?.itemsPerPage ?? 50;
  @Input() pageable?: Signal<IPageableSentrynel | undefined>;
  @Input() class: string = 'surface-50';
  @Output() page: EventEmitter<IPageEvent> = new EventEmitter<IPageEvent>();
  isMobile = this.screen.isMobile;

  constructor(
    private readonly screen: ScreenService,
  ) {
    
  }

  handlePageEvent(event: PageEvent) {
    this.page.emit({
      length: event.length,
      pageIndex: event.pageIndex,
      pageSize: event.pageSize,
      previousPageIndex: event.previousPageIndex
    })
  }
}
